import thunk from 'redux-thunk';
import storage from 'redux-persist/es/storage/session';
import { applyMiddleware, createStore } from 'redux';
import { persistCombineReducers } from 'redux-persist';
import { routerMiddleware } from 'react-router-redux';
import reducers from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension'
import { createBrowserHistory } from 'history'

const perist_config = {
  key: 'root',
  storage,
};

const history = createBrowserHistory();

const reducer = persistCombineReducers(perist_config, reducers);

const enhancers = [];

enhancers.push(
  applyMiddleware(
    thunk,
    routerMiddleware(history)
  )
);

const store = createStore(
  reducer,
  composeWithDevTools(...enhancers),
);

export { history }
export default store;